module.exports = __webpack_public_path__ + "img/ELITS.c29e0150.png";